import { render, staticRenderFns } from "./AttributeOverview.vue?vue&type=template&id=5207ac68"
import script from "./AttributeOverview.vue?vue&type=script&lang=js"
export * from "./AttributeOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports